import { MEMBERSHIP_EXTENSION_MODULE } from "@/api_framework/api_config";
import {
  IMembershipExtensionPostBody,
  IMembershipExtensionPostResponse,
} from "@/api_framework/api_modals/MembershipExtension";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
type MembershipExtensionCreateAPIResponse = { status: boolean; message: string };

export const useCreateMembershipExtensionAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IMembershipExtensionPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: MembershipExtensionCreateAPIResponse = await axios
          .post(MEMBERSHIP_EXTENSION_MODULE?.MEMBERSHIP_EXTENSION_CREATE?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipExtensionPostResponse>) => {
            if (res.data.status === true) {
              toast.success("Membership extension has been created.");
              return { status: true, message: res?.data?.data?.extension_id };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        return { status: false, message: null };
      }
    },
    [dispatch, configuration],
  );
  return { execute };
};
